/*
 *
 * App constants
 *
 */

export const UPDATE_AUTH_TOKEN = 'UPDATE_AUTH_TOKEN';
export const INITIAL_LOAD_FAILURE = 'INITIAL_LOAD_FAILURE';
export const AUTH_FAILURE = 'AUTH_FAILURE';
export const FETCH_TOKEN_DETAILS_REQUEST = 'FETCH_TOKEN_DETAILS_REQUEST';
export const FETCH_TOKEN_DETAILS_SUCCESS = 'FETCH_TOKEN_DETAILS_SUCCESS';
export const FETCH_TOKEN_DETAILS_FAILURE = 'FETCH_TOKEN_DETAILS_FAILURE';
export const THEME = 'THEME';
export const THEME_MODE = {
  '1': 'AMAZON',
  '2': 'AXIO_DARK',
  '3': 'W369_LIGHT',
  '4': 'MMT',
  '5': 'TATA_PAY',
  '6': 'AMAZON_NEW'
};

export const MESSAGES_THEME = {
  AMAZON_NEW: {
    EkycPage: {
      header: {
        defaultMessage: 'kyc45',
        byKycType: {
          300: 'kyc1',
        },
      },
    },
  },
};

export const getHeaderKey = (theme, kycType, defaultKey) => {
  const byKycType = MESSAGES_THEME[theme]
    && MESSAGES_THEME[theme].EkycPage
    && MESSAGES_THEME[theme].EkycPage.header
    && MESSAGES_THEME[theme].EkycPage.header.byKycType;
  return (byKycType && byKycType[kycType]) || defaultKey;
};